import { Button } from "react-bootstrap";
import "./ContactButton.css";
import { useHrStyles } from "../../Context/HRContext";

export default function ContactButton() {
  const hrStyles = useHrStyles();
  return (
    <>
      <div className="contact-button-wrapper mt-3 mb-5 flex justify-center">
        <Button href="/Contact" variant="outline-secondary" className="contact-button">
          Contact Us
        </Button>
      </div>
      <hr style={hrStyles} className="mb-5" />
    </>
  );
}
